import { PlatformData } from '../../../../../types/systems';
import { FieldRules, rules, runRules, ValidatedJsonType, ValidationResult } from '../validator';

export function isPlatformJson(value: ValidatedJsonType): ValidationResult {
	const json = value as PlatformData;

	const fields: FieldRules[] = [
		{
			key: 'specific_name',
			actual: json.specific_name,
			rules: [rules.isString(json.specific_name)],
		},
		{ key: 'type_name', actual: json.type_name, rules: [rules.isString(json.type_name)] },
		{ key: 'side', actual: json.side, rules: [rules.isNumber(json.side)] },
		{ key: 'id', actual: json.id, rules: [rules.optional(json.id, rules.isNumber(json.id))] },
		{ key: 'mobility', actual: json.mobility, rules: [rules.isString(json.mobility)] },
		{ key: 'subtype', actual: json.subtype, rules: [rules.isNumber(json.subtype)] },
		{
			key: 'sensor_elevation',
			actual: json.sensor_elevation,
			rules: [rules.isNumber(json.sensor_elevation)],
		},
		{ key: 'endurance', actual: json.endurance, rules: [rules.isNumber(json.endurance)] },
		{ key: 'base_speed', actual: json.base_speed, rules: [rules.isNumber(json.base_speed)] },
		{ key: 'dash_speed', actual: json.dash_speed, rules: [rules.isNumber(json.dash_speed)] },
		{
			key: 'max_roughness',
			actual: json.max_roughness,
			rules: [rules.isNumber(json.max_roughness)],
		},
		{ key: 'rest_period', actual: json.rest_period, rules: [rules.isNumber(json.rest_period)] },
		{
			key: 'min_altitude',
			actual: json.min_altitude,
			rules: [rules.isNumber(json.min_altitude)],
		},
		{
			key: 'rcs',
			actual: json.rcs,
			rules: [rules.optional(json.rcs, rules.isNumber(json.rcs))],
		},
		{
			key: 'confounders',
			actual: json.confounders,
			rules: [rules.optional(json.confounders, rules.isArray(json.confounders))],
		},
		{
			key: 'max_altitude',
			actual: json.max_altitude,
			rules: [rules.optional(json.max_altitude, rules.isNumber(json.max_altitude))],
		},
		{
			key: 'cost',
			actual: json.cost,
			rules: [rules.isString(json.cost), rules.noSpaces(json.cost)],
		},
	];

	return runRules(fields);
}

export const validatePlatform = (data: ValidatedJsonType): ValidationResult => {
	return isPlatformJson(data);
};
